/**
 * Copyright (c) HashiCorp, Inc.
 */

import type { TOC } from '@ember/component/template-only';

export interface ListItemSectionTitleSignature {
  Blocks: {
    default: [];
  };
  Element: HTMLDivElement;
}

const ListItemSectionTitle: TOC<ListItemSectionTitleSignature> = <template>
  <div
    class="cut-list-item-section__title hds-typography-body-200 hds-font-weight-semibold"
    ...attributes
  >
    {{yield}}
  </div>
</template>;

export default ListItemSectionTitle;
